import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";

export default class PremiumHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "premium":
                return this.handlePremium(model, params);
            case "premium/confirm":
                return this.handleConfirm(model, params);
            case "premium/cancel":
                return this.handleCancel(model, params);
            default:
                return model;
        }
    }

    private handlePremium(model: DiscussionModel, payload: any): DiscussionModel {
        model = model.showModalPremium();
        return model;
    }

    private handleConfirm(model: DiscussionModel, params: any): DiscussionModel {

        let url = "https://refresher.sk/plus";
        if (model.getLocale() == "cs") {
            url = "https://refresher.cz/plus";
        }

        window.setTimeout(() => {
            location.assign(url);
        }, 1);

        model = model.hideModalPremium();
        return model;
    }

    private handleCancel(model: DiscussionModel, params: any): DiscussionModel {
        model = model.hideModalPremium();
        return model;
    }

}